import React, { useEffect, useState } from 'react'
import { Button, makeStyles } from '@material-ui/core'
import { GRAY_COLORS } from 'asterX-UI'
import AccordionTwoHead from 'asterX-UI/Accordion/AccordionTwoHead'
import FieldInfoNG from 'asterX-UI/DataDisplay/FieldInfoNG'
import ChipStandard from 'asterX-UI/DataDisplay/ChipStandard'
import PhoneView from 'components/PhoneView'
import { SalesService } from 'lib/api'
import { useResErrors } from 'hooks'
import { LANGUAGES } from 'constants/client'
import moment from 'moment/moment'
import { colorStatusesByCode } from 'constants/deals'
import { Modal } from 'asterX-UI/Modals'
import { WorkListViewManagerDesktopModal } from 'pages/Desktop/WorkListView/Manager/WorkListView.manager.desktop'
import PageContainerDesktop from 'components/PageContainer/layout/PageContainer.desktop'
import HeaderBack from 'components/Desktop/HeaderBack'
import HistoryOfSelection from 'components/Desktop/HistoryOfSelection'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    width: '100%'
  },

  heading: {
    color: GRAY_COLORS[800],
    fontSize: 16,
    fontWeight: 600,

    lineHeight: '24px'
  },
  container: {
    marginTop: 10,
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    width: '100%'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'nowrap',
    alignItems: 'center',
    gap: 8
  }
}))
const style = {
  color: GRAY_COLORS[700],
  fontSize: 14,
  fontWeight: 400
}

const ClientHistory = ({ phone }) => {
  const classes = useStyles()
  const [clientHistory, setClientHistory] = useState([])
  const [loading, setLoading] = useState(false)
  const [checkWl, setCheckWl] = useState(null)
  const [pastSelection, setPastSelection] = useState(null)
  const { standardCheck } = useResErrors()
  useEffect(() => {
    if (phone) {
      getHistory()
    }
    return () => {}
  }, [phone])

  const getHistory = async () => {
    setLoading(true)
    await SalesService.getAllSalesByPhone(
      phone?.toString()?.toStandardPhone()
    ).then(res =>
      standardCheck(res, () => {
        setClientHistory(res.data?.listSales)
      })
    )
    setLoading(false)
  }

  return (
    <div className={classes.root}>
      <div className={classes.heading}>История клиента</div>
      {clientHistory?.map(v => (
        <AccordionTwoHead
          heading={`${v?.client?.firstName || ''} ${v?.client?.lastName || ''}`}
          key={`${v.id}`}
        >
          <div className={classes.container}>
            <div className={classes.row}>
              <FieldInfoNG
                label={'Телефон'}
                isVertical
                rootStyle={{
                  width: '59%'
                }}
              >
                <PhoneView
                  assignTo={v?.assignTo}
                  phone={v?.client?.phoneNumber || '-'}
                />
              </FieldInfoNG>
              <FieldInfoNG
                label={'Язык'}
                isVertical
                rootStyle={{
                  width: '40%'
                }}
                style={style}
              >
                {LANGUAGES.find(l => l.code === v?.client?.language)?.title ||
                  '-'}
              </FieldInfoNG>
            </div>
            <div className={classes.row}>
              <FieldInfoNG
                label={'Доп. телефон'}
                isVertical
                rootStyle={{
                  width: '59%'
                }}
              >
                <PhoneView
                  assignTo={v?.assignTo}
                  phone={v?.client?.additionalPhoneNumber || ''}
                />
              </FieldInfoNG>{' '}
              <FieldInfoNG
                label={'Дата'}
                isVertical
                rootStyle={{
                  width: '40%'
                }}
                style={style}
              >
                {moment(v?.createdDate).format('DD MMM YY')}
              </FieldInfoNG>
            </div>{' '}
            <div className={classes.row}>
              <FieldInfoNG
                label={'Менеджер'}
                isVertical
                rootStyle={{
                  width: '59%'
                }}
              >
                {v?.assignToFullName || v?.createdByFullname}
              </FieldInfoNG>{' '}
              <FieldInfoNG
                label={'Статус РЛ'}
                isVertical
                rootStyle={{
                  width: '40%'
                }}
              >
                <ChipStandard {...colorStatusesByCode(v.saleStatus?.code)}>
                  {v.saleStatus?.name}
                </ChipStandard>
              </FieldInfoNG>
            </div>
            <div
              className={classes.row}
              style={{
                marginTop: 21
              }}
            >
              <Button
                variant={'contained'}
                size={'small'}
                onClick={() =>
                  setPastSelection({
                    id: v.id,
                    tradeInCarVin: v?.tradeInCarVin || ''
                  })
                }
              >
                Смотреть прошлый подбор
              </Button>
              <Button
                variant={'contained'}
                color={'primary'}
                size={'small'}
                onClick={() => setCheckWl(v?.id)}
              >
                Перейти
              </Button>
            </div>
          </div>
        </AccordionTwoHead>
      ))}
      {checkWl && (
        <WorkListViewManagerDesktopModal
          open={!!checkWl}
          onClose={() => setCheckWl(null)}
          saleId={checkWl}
        />
      )}
      {pastSelection?.id && (
        <Modal
          open={pastSelection?.id}
          onClose={() => setPastSelection(null)}
          fullScreen
        >
          <PageContainerDesktop
            customHeader={
              <HeaderBack onClick={() => setPastSelection(null)}>
                История подбора
              </HeaderBack>
            }
          >
            <HistoryOfSelection
              id={pastSelection?.id}
              tradeInCarVin={pastSelection?.tradeInCarVin}
            />
          </PageContainerDesktop>
        </Modal>
      )}
    </div>
  )
}
export default ClientHistory
